// import { useContext } from "react";
// import { Popover } from "antd";
// import { Button } from "../../common";
// import { IconCaretDownFilled } from "@tabler/icons-react";
// import { GlobalContext } from "../../../lib/context";
// import request from "../../../utils/request";
// import React, { useEffect, useState } from 'react';
// import UserDetailsModal from './UserDetailsModal';


// interface User {
//   id: number;
//   full_name: string;
//   email: string;
//   // Add any other fields you want to store
// }

// const ProfileButton = () => {
//   const { profile, setAuth, setProfile } = useContext(GlobalContext);
//   // const navigate = useNavigate();
//   const path = `${process.env.REACT_APP_BASE_URL || ""}`;

//   const [user, setUser] = useState<User | null>(null);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [visible, setVisible] = useState(false);

//   const handleOpenChange = () => {
//     setVisible(true); // Toggles Popover visibility
//   };

//   const handleClose = () => {
//     setVisible(false); // Close the Popover
//   };

//   const handleClickOutside = (event: MouseEvent) => {
//     const popoverElement = document.querySelector('.ant-popover-content');
//     const triggerElement = document.querySelector('.popover-trigger');
    
//     // Close if the click is outside both the Popover and the trigger element
//     if (
//       visible &&
//       popoverElement &&
//       !popoverElement.contains(event.target as Node) &&
//       triggerElement &&
//       !triggerElement.contains(event.target as Node)
//     ) {
//       setVisible(false);
//     }
//   };

//   useEffect(() => {
//     // Add event listener for clicks
//     document.addEventListener('click', handleClickOutside);

//     // Cleanup on unmount
//     return () => {
//       document.removeEventListener('click', handleClickOutside);
//     };
//   }, [visible]);

//   useEffect(() => {
//     // Get the user from localStorage and parse it
//     let storedUser = profile;

//     if (storedUser) {
//       setUser(profile);
//     }
//   }, []); // The empty dependency array ensures this effect runs only once when the component mounts.

//   const handleOpenModal = () => {
//     setIsModalVisible(true);
//     setVisible(false); // Close the Popover
//   };

//   const handleCloseModal = () => {
//     setIsModalVisible(false);
//   };


//   const onLogout = () => {
//     request.clearToken();
//     setAuth(false);
//     setProfile({});
//     localStorage.removeItem("company_logo");
//   };

//   const content = (
//     <div className="d-flex flex-column" style={{ width: 140 }}>
//       <a href="https://help.coexsys.com/" target="_blank" rel="noopener noreferrer">
//         <Button
//           className="px-0! text-left"
//           outline={true}
//           hasBorder={false}
//         >
//           Knowledgebase
//         </Button>
//       </a>
//       <Button
//         onClick={() => handleOpenModal()}
//         className="px-0! text-left"
//         outline={true}
//         hasBorder={false}
//       >
//         Subscription Info
//       </Button>
//       {/* <Button
//         href="/navigation"
//         className="px-0! text-left"
//         outline={true}
//         hasBorder={false}
//       >
//         Go To Navigation
//       </Button> */}
//       <Button
//         onClick={onLogout}
//         className="px-0! text-left"
//         outline={true}
//         hasBorder={false}
//       >
//         Logout
//       </Button>
//     </div>
//   );

//   return (
//     <div>
//       <Popover content={content} trigger="click" placement="bottomRight" open={visible} onOpenChange={handleOpenChange} >
//         <div className="d-flex items-center gap-1 py-2 pl-2">
//           <div className="cursor-pointer">{profile.full_name}</div>
//           <IconCaretDownFilled size={16} color="#666" />
//         </div>
//       </Popover>
//       <UserDetailsModal
//         visible={isModalVisible}
//         onClose={handleCloseModal}
//       />
//     </div>

//   );
// };

// export { ProfileButton };

import { useContext, useEffect } from "react";
import { Popover } from "antd";
import { Button } from "../../common";
import { IconCaretDownFilled } from "@tabler/icons-react";
import { GlobalContext } from "../../../lib/context";
import request from "../../../utils/request";
import React, { useState } from 'react';
import UserDetailsModal from './UserDetailsModal';

interface User {
  id: number;
  full_name: string;
  email: string;
}

const ProfileButton = () => {
  const { profile, setAuth, setProfile } = useContext(GlobalContext);
  const [user, setUser] = useState<User | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  // Add effect to handle outside clicks
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      // Check if click is outside the popover and its trigger
      const isOutsidePopover = !target.closest('.ant-popover');
      const isOutsideTrigger = !target.closest('.profile-trigger');
      
      if (visible && isOutsidePopover && isOutsideTrigger) {
        setVisible(false);
      }
    };

    // Add event listener when popover is visible
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  useEffect(() => {
    if (profile) {
      setUser(profile);
    }
  }, [profile]);

  const handleOpenModal = () => {
    setIsModalVisible(true);
    setVisible(false);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const onLogout = () => {
    request.clearToken();
    setAuth(false);
    setProfile({});
    localStorage.removeItem("company_logo");
  };

  const content = (
    <div className="d-flex flex-column" style={{ width: 140 }}>
      <a href="https://help.coexsys.com/" target="_blank" rel="noopener noreferrer">
        <Button
          className="px-0! text-left"
          outline={true}
          hasBorder={false}
        >
          Knowledgebase
        </Button>
      </a>
      <Button
        onClick={handleOpenModal}
        className="px-0! text-left"
        outline={true}
        hasBorder={false}
      >
        Subscription Info
      </Button>
      <Button
        onClick={onLogout}
        className="px-0! text-left"
        outline={true}
        hasBorder={false}
      >
        Logout
      </Button>
    </div>
  );

  return (
    <div>
      <Popover 
        content={content} 
        trigger="click" 
        placement="bottomRight" 
        open={visible}
        onOpenChange={setVisible}
      >
        <div className="d-flex items-center gap-1 py-2 pl-2 profile-trigger">
          <div className="cursor-pointer">{profile.full_name}</div>
          <IconCaretDownFilled size={16} color="#666" />
        </div>
      </Popover>
      <UserDetailsModal
        visible={isModalVisible}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export { ProfileButton };

